import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { TipoAnexoDto } from '../../../dto/expediente/tipo-anexos.dto';
import { ActivatedRoute, Router } from '@angular/router';
import { AvanceProcesalService } from '../../../services/avance-procesal.service';
import { ArchivosFormDTO } from '../../../dto/expediente/archivos-form.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { Location } from '@angular/common';
import {TranslateService} from "@ngx-translate/core";
import {TipoDocumentoDto} from "../../../dto/expediente/tipo-documento.dto";
import {ListasService} from "../../../services/listas.service";
import { combineLatest } from 'rxjs';
import { FormField, FormFieldOption } from '../../../dto/util/form-field';
import { ParametrizacionService } from '../../../services/parametrizacion.service';
@Component({
  selector: 'app-avance-procesal',
  templateUrl: './avance-procesal.component.html',
  styleUrl: './avance-procesal.component.scss',
})
export class AvanceProcesalComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  public solicitudForm!: FormGroup;
  public selectedOption: TipoAnexoDto = {};
  public minFileSize = 0;
  public maxFileSize = 0;
  public entidadId: number;
  private expedienteId: number;
  public extensionesAcceptadas: string | null = null;
  public files: File[] = [];
  public canChooseFiles = false;
  public showErrorMaxFiles = false;
  public userData: UserDataDto = {};
  public maxLengthAsunto = Constants.MAX_LENGTH_ASUNTO;
  public maxLengthDescripcion = Constants.MAX_LENGTH_DESCRIPCION;
  public maxLengthNombre = Constants.MAX_LENGTH_NOMBRE;
  public maxLengthApellidos = Constants.MAX_LENGTH_APELLIDOS;
  public maxLengthCorreo = Constants.MAX_LENGTH_CORREO;
  public maxLengthCedula = Constants.MAX_LENGTH_CEDULA;
  public Constants = Constants;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  // Multilenguaje
  guiaText: any = {};
  guiaAvanceProcesalText: any = {};
  avanceProcesalText: any = {};

  // Listas
  tiposDocumento: TipoDocumentoDto[] = [];
  listasSolicitud: FormFieldOption[] = [];
  terminosTexto: string = '';
  mostrarTerminos: boolean = false;
  terminosAceptados: boolean = false;
  formDataPendiente: FormData | null = null;
  pesoMaxArchivosSIC!: number;
  constructor(
    private fb: FormBuilder,
    private avanceProcesalService: AvanceProcesalService,
    private alertaModalService: AlertaModalService,
    private router: Router,
    private utilService: UtilService,
    private location: Location,
    private translate: TranslateService,
    private listasService: ListasService,
    private parametrizacionService: ParametrizacionService,
  ) {
    this.expedienteId = this.activatedRoute.snapshot.params['expedienteId'];
    this.entidadId = this.activatedRoute.snapshot.params['entidadId'];


    // Multilenguaje
    combineLatest({
      guiaInteractiva: this.translate.stream('guias-interactivas'),
      guiaAvanceProcesal: this.translate.stream('guia-avance-procesal'),
      avanceProcesal: this.translate.stream('crear-solicitud')
    }).subscribe(({ guiaInteractiva, guiaAvanceProcesal, avanceProcesal }) => {
      // Asignar traducciones a variables
      this.guiaText = guiaInteractiva;
      this.guiaAvanceProcesalText = guiaAvanceProcesal;
      this.avanceProcesalText = avanceProcesal;
      this.ngOnInit();
    });
  }

  buildForm() {
    this.solicitudForm = this.fb.group({
      asunto: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
          Validators.maxLength(300),
        ],
      ],
      nombres: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.maxLength(50),
        ],
      ],
      apellidos: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.maxLength(50),
        ],
      ],
      tipoDocId: ['', Validators.required],
      cedula: ['', [Validators.required]],
      correo: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(100)],
      ],
      tipoAnexo: ['', [Validators.required]],
      archivos: [null],
      tipoSolicitud: [Validators.required,this.entidadId === Constants.ID_ENTIDAD_SIC ? Constants.TIPO_SOLICITUD_UNO : ''],
      solicitud: [''],
      descripcion: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_DESCRIPCION),
          Validators.maxLength(Constants.MAX_LENGTH_DESCRIPCION),
        ],
      ],
    });

    if (this.entidadId == Constants.ID_ENTIDAD_SIC) {
      this.ValidacionesEntidadSIC();
    }
  }
  ValidacionesEntidadSIC() {
    const tipoSolicitud = this.solicitudForm.get('tipoSolicitud')?.value;
    this.removeAllValidators();
    this.solicitudForm.get('tipoSolicitud')?.setValidators([Validators.required]);
    this.solicitudForm.get('archivos')?.setValidators([Validators.required]);

    if (tipoSolicitud == Constants.TIPO_SOLICITUD_UNO) {
      this.solicitudForm.get('solicitud')?.setValidators([Validators.required]);

      this.solicitudForm.get('descripcion')?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_DESCRIPCION),
        Validators.maxLength(Constants.MAX_LENGTH_DESCRIPCION)
      ]);
    }

    Object.values(this.solicitudForm.controls).forEach(control => {
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  ValidacionesEntidades() {
    this.removeAllValidators();

    this.solicitudForm.get('asunto')?.setValidators([
      Validators.required,
      Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
      Validators.maxLength(300)
    ]);

    this.solicitudForm.get('nombres')?.setValidators([
      Validators.required,
      Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      Validators.maxLength(50)
    ]);

    this.solicitudForm.get('apellidos')?.setValidators([
      Validators.required,
      Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      Validators.maxLength(50)
    ]);

    this.solicitudForm.get('tipoDocId')?.setValidators([Validators.required]);
    this.solicitudForm.get('cedula')?.setValidators([Validators.required]);
    this.solicitudForm.get('correo')?.setValidators([Validators.required, Validators.email]);

    this.solicitudForm.get('archivos')?.setValidators([Validators.required]);

    this.solicitudForm.updateValueAndValidity();
  }
  removeAllValidators() {
    Object.keys(this.solicitudForm.controls).forEach(key => {
      const control = this.solicitudForm.get(key);
      control?.clearValidators();
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }
  ngOnInit(): void {
    this.buildForm();
    // Se listan los tipos de documento
    this.listasService
      .getDocumentTypeList()
      .subscribe(response => {
        this.tiposDocumento = response;
      });
    if (this.entidadId == Constants.ID_ENTIDAD_SIC) {
        const peso=this.obtenerPesoArchivosSIC();
        this.getListas();
        this.solicitudForm.get('tipoSolicitud')?.valueChanges.subscribe(() => {
            this.ValidacionesEntidadSIC();
          });
    }
    // Se toma la información del usuario que inicia sesión
    this.userData = JSON.parse(
      sessionStorage.getItem('user_information_session')!
    );
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaAvanceProcesalText['info-titulo'],
      descripcionPantalla: this.guiaAvanceProcesalText['info-descripcion'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaAvanceProcesalText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#form-solicitud',
          popover: {
            title: this.guiaAvanceProcesalText['formulario-titulo'],
            description: this.guiaAvanceProcesalText['formulario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#archivos',
          popover: {
            title: this.guiaAvanceProcesalText['archivos-titulo'],
            description: this.guiaAvanceProcesalText['archivos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#boton-envio',
          popover: {
            title: this.guiaAvanceProcesalText['boton-envio-titulo'],
            description: this.guiaAvanceProcesalText['boton-envio-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (this.userData.primerInicioSesion) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

  setFilesFormValue(event: ArchivosFormDTO) {
    this.solicitudForm.patchValue({
      archivos: event.Archivos,
      tipoAnexo: event.tipoAnexo,
    });
  }

  validateInputLength(event: Event, maxLength: number) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > maxLength) {
      inputElement.value = inputElement.value.slice(0, maxLength);
    }
  }

  onSubmit() {
    const form = this.solicitudForm;
    const archivos = form.get('archivos')?.value;
    const tipoSolicitud = form.get('tipoSolicitud')?.value;

    if (this.entidadId == Constants.ID_ENTIDAD_SIC) {
      // Validar tipo de solicitud
      if (!tipoSolicitud) {
        form.get('tipoSolicitud')?.markAsTouched();
        return;
      }

      if (tipoSolicitud == Constants.TIPO_SOLICITUD_UNO) {
        const solicitud = form.get('solicitud')?.value;
        const descripcion = form.get('descripcion')?.value;

        if (!solicitud) {
          form.get('solicitud')?.markAsTouched();
          return;
        }

        if (!descripcion || form.get('descripcion')?.invalid) {
          form.get('descripcion')?.markAsTouched();
          return;
        }

        if (!archivos || archivos.length === 0) {
          this.alertaModalService.error('Debe adjuntar al menos un archivo.');
          return;
        }

        const formData = new FormData();
        formData.append('solicitud', solicitud);
        formData.append('asunto', descripcion);
        formData.append('tipoAnexo', form.get('tipoAnexo')?.value ?? '');

        archivos.forEach((file: File) => formData.append('archivos', file));
        if (!this.terminosAceptados) {
          if (this.solicitudForm.valid) {
            this.formDataPendiente = formData;
            this.obtenerTerminosSIC();
            return;
          }
        }
        this.sendForm(formData);
        return;
      }

      if (tipoSolicitud == Constants.TIPO_SOLICITUD_DOS) {
        if (!archivos || archivos.length === 0) {
          this.alertaModalService.error('Debe adjuntar al menos un archivo.');
          return;
        }

        const formData = new FormData();
        formData.append('tipoAnexo', form.get('tipoAnexo')?.value ?? '');
        archivos.forEach((file: File) => formData.append('archivos', file));
        if (!this.terminosAceptados) {
          if (this.solicitudForm.valid) {
            this.formDataPendiente = formData;
            this.obtenerTerminosSIC();
            return;
          }
        }
        this.sendForm(formData);
        return;
      }
    }

    if (form.valid) {
      const formData = this.createFormData();
      this.sendForm(formData);
    }
  }


  createFormData(): FormData {
    const formValue = this.solicitudForm.value;
    const formData = new FormData();

    formData.append('usuarioId', '' + this.userData.idUsuario);

    if (this.entidadId == Constants.ID_ENTIDAD_SIC) {
      const tipoSolicitud = formValue.tipoSolicitud;

      if (tipoSolicitud == Constants.TIPO_SOLICITUD_UNO) {
        formData.append('solicitud', formValue.solicitud ?? '');
        formData.append('asunto', formValue.descripcion ?? '');
        formData.append('tipoAnexo', formValue.tipoAnexo ?? '');
        if (formValue.archivos) {
          Array.from(formValue.archivos as FileList).forEach((file: File) => {
            formData.append('archivos', file);
          });
        }
        return formData;
      }

      if (tipoSolicitud == Constants.TIPO_SOLICITUD_DOS) {
        formData.append('tipoAnexo', formValue.tipoAnexo ?? '');
        if (formValue.archivos) {
          Array.from(formValue.archivos as FileList).forEach((file: File) => {
            formData.append('archivos', file);
          });
        }
        return formData;
      }
    }

    const fields = ['asunto', 'nombres', 'apellidos', 'tipoDocId', 'cedula', 'correo', 'tipoAnexo'];
    fields.forEach(field => formData.append(field, formValue[field] ?? ''));
    if (formValue.archivos) {
      Array.from(formValue.archivos as FileList).forEach((file: File) => {
        formData.append('archivos', file);
      });
    }
    return formData;
  }


  // Función que transforma el texto ingresado en mayúsculas
  transformToUppercase(fieldName: string): void {
    const control = this.solicitudForm.get(fieldName);
    if (control) {
      const uppercasedValue = control.value.toUpperCase();
      control.setValue(uppercasedValue, { emitEvent: false });
    }
  }

  // Función que valida los tipos de documento y agrega las validaciones correspondientes
  validarTiposDocumento() {
    if (
      this.solicitudForm.get('tipoDocId')?.value == 1 ||
      this.solicitudForm.get('tipoDocId')?.value == 2 ||
      this.solicitudForm.get('tipoDocId')?.value == 5
    ) {
      this.solicitudForm
        .get('cedula')
        ?.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern(/^\d+$/),
        ]);
    } else if (this.solicitudForm.get('tipoDocId')?.value == 4) {
      this.solicitudForm
        .get('cedula')
        ?.setValidators([
          Validators.required,
          Validators.maxLength(8),
          Validators.pattern(
            Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
          ),
        ]);
    } else {
      this.solicitudForm
        .get('cedula')
        ?.setValidators([
          Validators.required,
          Validators.maxLength(9),
          Validators.pattern(
            /^\d+$/
          ),
        ]);
    }
    this.solicitudForm.get('tipoDocId')?.updateValueAndValidity();
    this.solicitudForm.get('cedula')?.updateValueAndValidity();
  }
  getListas() {
    this.listasService
      .getListaValor(Constants.AVANCE_PROCESAL_SIC)

      .subscribe(response => {
        this.listasSolicitud = response as FormFieldOption[];
      });
  }
  sendForm(formData: FormData) {
    this.avanceProcesalService
      .postCrearAvanceProcesal(this.expedienteId, formData)
      .subscribe(() => {
        this.alertaModalService.exito(this.avanceProcesalText['exito-creacion']);
        this.location.back();
      });
  }
  obtenerTerminosSIC() {
   this.parametrizacionService
    .obtenerParametroPorNombre(Constants.TERMINOS_CONDICIONES_SIC)
    .subscribe({
      next: (respuesta) => {
        this.mostrarTerminos = true;
        this.terminosTexto = respuesta.valor_parametro;
      },
      error: (err) => {
       console.error('Error al obtener el parámetro', err);
      },
    });
  }
  aceptarTerminos() {
    this.terminosAceptados = true;
    this.mostrarTerminos = false;
    if (this.formDataPendiente) {
      this.sendForm(this.formDataPendiente);
      this.formDataPendiente = null;
    }
  }

  rechazarTerminos() {
    this.terminosAceptados = false;
    this.mostrarTerminos = false;
  }
  obtenerPesoArchivosSIC() {
    this.parametrizacionService
      .obtenerParametroPorNombre(Constants.PESO_ARCHIVO_SIC)
      .subscribe(resp => {
        this.pesoMaxArchivosSIC = Number(resp.valor_parametro);
      });
  }
}
